exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#actions-container {\n  margin-left: auto;\n}\n", ""]);

// exports
